export default __webpack_public_path__ + "static/TierFour-dfad9e40630b63a2500fb80174671732.webp";